import React from "react";
import { Route, Switch } from "react-router-dom";
import { ConnectedRouter as Router } from "react-router-redux";

import PrivateRoute from "@components/private-route";
import history from "./history";
import Login from "../user/login";
import Home from "../home";
import ResetPassword from "../user/reset-password";

const router: React.StatelessComponent = () => {
  return (
    <Router history={history}>
      <Switch>
        <Route path="/resetPassword" render={() => <ResetPassword />} />
        <Route path="/login" component={Login} />
        <PrivateRoute path="/" component={Home} />
      </Switch>
    </Router>
  );
};

export default router;
